import { forwardRef as forwardRef$1 } from 'react';

/* eslint-disable @typescript-eslint/ban-types */
// Custom forwardRef implementation, enables use of forwardRef with generics and as prop, taken from:
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/core/system/src/system.types.tsx#L38
function forwardRef(component) {
    return forwardRef$1(component);
}

export { forwardRef };
